import * as types from '../mutation-types'
import {unionState} from '../union-state'

const state = {
	materials_tree: [],
	warehouse_materials: [],
	materials: [],
};
const actions = {
	fetchTree({ commit },  warehouseId ) {
		return window.axios.get(`Warehouses/${warehouseId}/MaterialsTree`
		).then(response => {
			commit(types.STORE_MATERIALS_TREE, response.data);
			return response.data;
		});
	},

	fetchAll({ commit }) {
		return window.axios.get('Warehouses/Materials'
		).then(response => {
			commit(types.STORE_MATERIALS, response.data);
			return response.data;
		});
	},
	fetch({ commit }, { warehouseId, materialId }) {
		return window.axios.get(`Warehouses/${warehouseId}/Materials/${materialId}`
		).then(response => {
			commit(types.STORE_ONE_MATERIAL, response.data);
			return response.data;
		});
	},

	/* eslint-disable no-unused-vars */
	fetchLastPurchasePrice({ commit }, materialId ) {
		return window.axios.get(`MaterialFlow/Invoices/${materialId}/LastPurchasePrice`
		).then(response => {
			return response.data;
		});
	},
	/* eslint-enable no-unused-vars */

	fetchWarehouseMaterials({ commit }, warehouseId ) {
		return window.axios.get(`Warehouses/${warehouseId}/Materials`).then(response => {
			commit(types.STORE_WAREHOUSE_MATERIALS, response.data);
			return response.data;
		});
	},

	create({ commit }, { warehouseId, material }) {
		return window.axios.post(`Warehouses/${warehouseId}/Materials`, {
            name: material.name,
            inner_no: material.inner_no,
            type: material.type,
            category: material.category,
            purchase_price: material.purchase_price,
            sale_price: material.sale_price,
            notes: material.notes,
            parent_id: material.parent_id,
            purchases_account_id: material.purchases_account_id,
            purchases_refund_account_id: material.purchases_refund_account_id,
            sales_account_id: material.sales_account_id,
            sales_refund_account_id: material.sales_refund_account_id,
            manufacturer: material.manufacturer,
            min_quantity: material.min_quantity,
            max_quantity: material.max_quantity,
            specifications: material.specifications,
			unit_size_id: material.unit_size_id,
			barcode: material.barcode
		}).then(response => {
			commit(types.STORE_ONE_MATERIAL, response.data)
			return response.data;
		});
	},

	update({ commit }, { warehouseId, material }) {
		return window.axios.put(`Warehouses/${warehouseId}/Materials/${material.id}`, {
			id: material.id,
            name: material.name,
            inner_no: material.inner_no,
            type: material.type,
            category: material.category,
            purchase_price: material.purchase_price,
            sale_price: material.sale_price,
            notes: material.notes,
            parent_no: material.parent_id, // Patch #8017 bug
            purchases_account_id: material.purchases_account_id,
            purchases_refund_account_id: material.purchases_refund_account_id,
            sales_account_id: material.sales_account_id,
            sales_refund_account_id: material.sales_refund_account_id,
            manufacturer: material.manufacturer,
            min_quantity: material.min_quantity,
            max_quantity: material.max_quantity,
            specifications: material.specifications,
			unit_size_id: material.unit_size_id,
			barcode: material.barcode
		}).then( response => {
			commit(types.STORE_ONE_MATERIAL, response.data);
			return response.data;
		});
	},
	updateinventoryPrice({ commit }, { warehouse_id, material_id, invevtory_price }) {
		return window.axios.put(`Warehouses/${warehouse_id}/Materials/${material_id}/InventoryPrice`, { 
			invevtory_price
		}).then( response => {
			commit('', '');
			return response.data;
		});
	},
	delete({ commit }, { warehouseId, materialId }) {
		return window.axios.delete(`Warehouses/${warehouseId}/Materials/${materialId}`).then(() => {
			commit(types.DELETE_MATERIAL, materialId)
		});
	},
	
	GenerateNewInnerNo({commit}, {warehouseId, materialId}){
		return window.axios.get(`Warehouses/${warehouseId}/Materials/${materialId}/GenerateNewNo`).then(response => {
			commit('', '')
			return response.data;
		});
	}
};

const mutations = {
	[types.STORE_MATERIALS_TREE](state, materials_tree) {
		state.materials_tree = materials_tree;
	},
    
	[types.STORE_MATERIALS](state, materials) {
		state.materials = materials;
	},

    [types.STORE_WAREHOUSE_MATERIALS](state, warehouse_materials) {
		state.warehouse_materials = warehouse_materials;
	},

	[types.STORE_ONE_MATERIAL](state, material) {
		state.warehouse_materials = unionState(state.warehouse_materials, [material]);
	},

	[types.DELETE_MATERIAL](state, material) {
		state.warehouse_materials = unionState(state.warehouse_materials, [material]);
	},
};

const getters = {
	getById: state => id => state.warehouse_materials.find(t => t.id === id),
	getMaterialById: state => id => state.materials.find(c => c.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

